export class ApiError {
    constructor(obj: ApiError = {} as ApiError) {
        Object.assign(this, obj);
    }
    name?: string = "Api Error";
    message: string;
    stack?: string;
}


// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/api-error.ts